import React from 'react';
import Tela from "./componentes/atomos/tela/Canvas";
import CaixaTool from "./componentes/organismos/Caixa deFerramentas/Caixaferramentas"
import './App.css';

function App() {

 
  return (
    <div className="App">

      <header className="header">

        ÀWÒRÁN
        
        </header>

       <CaixaTool></CaixaTool>
       <Tela> </Tela>


          <footer>Odaraya mello - WbGl</footer>

    </div>
  );
}

export default App;
